import { css } from 'linaria'
import * as layoutStyles from '../../../components/layout/layout.styles'

const balanceWrapperStyles = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-around',
  [layoutStyles.breakpointSmall]: {
    width: 'auto',
    flexDirection: 'row',
    '& > *': {
      borderRight: '1px solid rgba(152, 152, 152, 0.5)'
    }
  }
}

export const balanceWrapper = css`
  ${balanceWrapperStyles};
  border: 1px solid black;
  border-left: 10px solid black;
  margin: 1rem 0;
`

export const emptySpace = css`
  width: 100%;
`
